import debouce from 'lodash.debounce';

const defaultTimeout = 300;

export const debounce = (callback, time = defaultTimeout) => {
  return debouce(callback, time);
};
